import clsx from "clsx";
import React from "react";
import { Box, BoxProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { LibraryNavItemListItem } from "./LibraryNavItemListItem";
import { menuItems } from "../app/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },

  more: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 14,
    fontWeight: 500,
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),

    "&:hover": {
      background: "none !important",
    },

    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
}));

export interface LibraryNavItemListProps extends BoxProps {}

export function LibraryNavItemList(props: LibraryNavItemListProps) {
  const { className, ...other } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      {menuItems.library.map(({ text, link, Icon }, index) => (
        <>
          <LibraryNavItemListItem
            key={index}
            link={link}
            name={text}
            IconComponent={Icon}
          />
        </>
      ))}
    </Box>
  );
}
